import { render, staticRenderFns } from "./MyNarratives.vue?vue&type=template&id=9db9aabc&"
import script from "./MyNarratives.vue?vue&type=script&lang=js&"
export * from "./MyNarratives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports